export default __webpack_public_path__ + "static/media/image_resolution_decreaser.py.d78eee0d.txt";